<template>
    <section class="bg-white border-bottom">

        <div @click="toggleDetails()" class="text-gray-500 text-uppercase font-weight-bold px-4 py-25 bg-gray-100 cursor-pointer">
            <i class="fas fa-tasks fa-fw mr-1"></i> Your Tasks <i class="fas" :class="showDetails == false ? 'fa-caret-right' : 'fa-caret-down'"></i>
        </div>

        <div  class="px-4 py-25">
            <div @click="toggleDetails()" class="d-flex pb-2" style="border-bottom: 1px solid #e4e5e6">
                <div class="flex-fill text-center">
                    <span class="text-3xl leading-none">{{ todayTasks ? todayTasks.length : '0' }}</span><br>
                    <span class="text-sm text-gray-500 leading-tight">Due Today</span>
                </div>
                
                <div class="flex-fill text-center" style="line-height:24px">
                    <span class="text-3xl leading-none">{{ upcomingTasks  ? upcomingTasks.length : '0' }}</span><br>
                    <span class="text-sm text-gray-500 leading-tight">Coming Up</span>
                </div>
            </div>


            <div class="px-1 py-1">

                <div class="pb-2" v-if="showDetails" style="margin:0 -1.5rem;">
                    <div v-if="tasks.length === 0" class="text-medium text-gray-500 text-center">
                        <div class="rounded-circle m-auto" style="width:2rem; height:2rem; line-height:2rem; background:#a4aaae; opacity:.5;">
                            <i class="fas fa-tasks text-medium text-white" style="line-height:2rem"></i></div>
                            Woohoo! You're all caught up with your tasks.
                    </div>    
                	<div v-else>
                        <ul v-if="todayTasks.length > 0" class="list-group list-group-flush list-group-borderless" style="border:1px solid transparent">
                            <div class="section-label text-transform-none pt-25 px-35">Today</div>
                            <task v-for="task in todayTasks"
                                :key="task.id"
                                :task="task"
                                :show_edit="false"
                                @status-changed="changeStatus($event)" />            
                        </ul>
                    
                        <ul v-if="upcomingTasks.length > 0" class="list-group list-group-flush list-group-borderless" style="border:1px solid transparent">
                            <div class="section-label text-transform-none pt-25 px-35" style="border-top:1px solid #dee2e6">Coming Up</div>
                            <task v-for="task in upcomingTasks"
                                :key="task.id"
                                :task="task"
                                :show_edit="false"
                                @status-changed="changeStatus($event)" />  
                        </ul>
                    </div>  
                </div>

                <div v-if="showDetails" style="margin:0 -.25rem; border-bottom:1px solid #e4e5e6;"></div>

                <div class="pt-2 text-right">
                    <router-link :to="{ name: 'tasks' }" class="btn btn-sm btn-ghost-primary">Manage Tasks</router-link>
                </div>                

            </div>
        </div>  
    </section>
</template>

<script>

    import Task from './Task'

	export default {

        components: {
            Task,
        },

        props: {
            tasks: Array,
        },

        data() {
            return {
                current: moment(),
                showDetails: false,
                all_tasks: [],
            }
        },

        created() {
        	this.all_tasks = this.tasks;
        },

        methods: {
            changeStatus($event) {
                axios.put('/api/tasks/' + $event.id + '/status', $event)
                    .then(({ data }) => { 
                        //update the task in the list
                        let index = this.all_tasks.map(task => { return task.id; }).indexOf($event.id);
                        this.all_tasks[index].status = $event.status;
                        this.all_tasks[index].updated_at = data.updated_at;
                })              
            },
            toggleDetails() {
                this.showDetails = !this.showDetails;
            },  
        },

        computed: {
            todayTasks() {
                if (this.all_tasks.length > 0 ) {
                return _.orderBy(
                    this.all_tasks.filter(task => {
                        return (moment(task.due_date).diff(this.current, 'days') <= 1) && (task.status == 0);
                    }),
                    'due_date', 'asc');
                }                
            },

            upcomingTasks() {
                if (this.all_tasks.length > 0) {
                return _.orderBy(
                    this.all_tasks.filter(task => {
                        return (moment(task.due_date).diff(this.current, 'days') > 1) && (task.status == 0);
                    }),
                    'due_date', 'asc');   
                }  
            },

            completedTasks() {
                if (this.all_tasks.length > 0) {
                return _.orderBy(
                    this.all_tasks.filter(task => {
                        return (this.current.diff(moment(task.completed_date), 'days') <= 7) && task.status > 0;
                    }),
                    'updated_at', 'desc');
                }
            },
        },
   
    }
</script>

<style>

</style>